import client from "./client";

export const zendeskApi = {
  getStatus: () => client.get("/zendesk/status"),
  listBrands: () => client.get("/zendesk/brands"),
  updateBrandMapping: (brandId: string, datasourceKey: string | null, brandName: string) =>
    client.patch(`/zendesk/brands/${brandId}`, { datasource_key: datasourceKey, brand_name: brandName }),
  listDatasources: () => client.get("/zendesk/datasources"),
};
